import React from "react"

export default function Social(){
    return(
        <div className="home--social">
            <a href="https://github.com/chatbot-1" className="home--social-icon" target="_blank">
                <i class="uil uil-github"></i>
            </a>
            <a href="https://www.linkedin.com/in/atul-singh-1091131ba/" className="home--social-icon" target="_blank">
                <i class="uil uil-linkedin"></i>
            </a>
            <a href="https://twitter.com/itsmeatul_" className="home--social-icon" target="_blank">
                <i class="uil uil-twitter"></i>
            </a>
        </div>
    )
}